import { useEffect } from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { BrandWidgetDetailV2, ExposureWidgetItemBrand } from '../../../../../types/widget';
import { getRandomNumber } from '../../../../../lib/common';
import { BrandItemV2 } from '../../../../../types/brand/list';

type UseBrandWidgetFormReturnType = {
  layoutType?: BrandWidgetDetailV2['layoutType'];
  exposureWidgetItemBrands?: BrandWidgetDetailV2['exposureWidgetItemBrands'];
  handleChangeBrandList: (brands: BrandItemV2[]) => void;
  handleChangeExposureWidgetItemBrands: (exposureBrandList: ExposureWidgetItemBrand[]) => void;
};

interface BrandWidgetFormProps {
  form: WrappedFormUtils;
  initialValue: Partial<BrandWidgetDetailV2>;
  changeTab: (tab: number) => void;
}

export const useBrandWidgetForm = (props: BrandWidgetFormProps): UseBrandWidgetFormReturnType => {
  const { form, initialValue, changeTab } = props;

  const { exposureWidgetItemBrands, layoutType } = form.getFieldsValue([
    'exposureWidgetItemBrands',
    'layoutType',
  ]) as Pick<Partial<BrandWidgetDetailV2>, 'exposureWidgetItemBrands' | 'layoutType'>;

  useEffect(() => {
    form.setFieldsValue(initialValue);
  }, []);

  const handleChangeBrandList = (brands: BrandItemV2[]): void => {
    const newList = brands.map((brand) => {
      const findBeforeSelectedBrand = exposureWidgetItemBrands?.find((item) => item.brand.id === brand.id);
      if (findBeforeSelectedBrand) return findBeforeSelectedBrand;
      return { id: getRandomNumber(), brand, title: brand.name, attachment: [], contents: '' };
    });

    form.setFieldsValue({
      exposureWidgetItemBrands: newList,
    });

    changeTab(newList[0]?.id);
  };

  const handleChangeExposureWidgetItemBrands = (exposureBrandList: ExposureWidgetItemBrand[]): void => {
    form.setFieldsValue({
      widgetBrandList: exposureBrandList.map((item) => item.brand),
    });
  };

  return { layoutType, exposureWidgetItemBrands, handleChangeBrandList, handleChangeExposureWidgetItemBrands };
};
